




















































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import { QUESTION_SURVEY_TYPES, QUESTION_TEST_TYPES } from '../const/question-types'
import { mapGetters } from 'vuex'
import QuestionType from '../lib/QuestionType'
import Question from '../models/Question'
import { State, Getter, Action, Mutation, BusAction } from '../store-helper'
import ToolbarComponent from './ToolbarComponent.vue'
import { qEditorState } from '../stores'

@Component({
  components: {
    ToolbarComponent
  }
})
export default class EditorToolbarComponent extends Vue {
  get currentLine() {
    return qEditorState.currentLine
  }

  get previousLine() {
    return qEditorState.previousLine
  }

  get question() {
    return qEditorState.question
  }

  fontSize = '12';

  fontSizes = ()=>{
    const list: string[] = [];
    for (let index = 8; index < 40; index = index + 2) {
      list.push(`${index}`)
    }
    return list
  }

  @Watch('fontSize', {immediate: true})
  watchFontSize(){
    this.emit({
      event: 'insertSnippet',
      payload: {
        type: 'fontsize',
        fontSize: this.fontSize
      }
    })
  }

  @BusAction emit
  get isRevisionMode() {
    return qEditorState.isRevisionMode
  }

  colors = {
    hex: '#000000',
    hsl: { h: 150, s: 0, l: 0, a: 1 },
    hsv: { h: 150, s: 0, l: 0, a: 1 },
    rgba: { r: 0, g: 0, b: 0, a: 1 },
    a: 1
  }

  @Watch('colors')
  watchColors(val, oldVal) {
    this.addColor(val.hex)
  }

  constructor() {
    super()
  }

  private get surveyTypes() {
    return QUESTION_SURVEY_TYPES
  }

  private get testTypes() {
    return QUESTION_TEST_TYPES
  }

  public heading() {
    this.emit({
      event: 'insertSnippet',
      payload: {
        type: 'heading',
        content: '# ${1:内容}\n'
      }
    })
    this.emit({ event: 'focus' })
  }

  public bold() {
    this.emit({
      event: 'insertSnippet',
      payload: {
        type: 'bold',
        content: '** ${1:内容} **'
      }
    })
    this.emit({ event: 'focus' })
  }

  public quote() {
    this.emit({
      event: 'insertSnippet',
      payload: {
        type: 'quote',
        content: '> ${1:内容}\n'
      }
    })
    this.emit({ event: 'focus' })
  }

  public link() {
    this.emit({
      event: 'insertSnippet',
      payload: {
        type: 'link',
        content: '[${1:タイトル}](${2:http://}) '
      }
    })
    this.emit({ event: 'focus' })
  }

  public list() {
    this.emit({
      event: 'insertSnippet',
      payload: {
        type: 'list',
        content: '- ${1:内容}\n'
      }
    })
    this.emit({ event: 'focus' })
  }

  public onMathLiveClick() {
    this.emit({
      event: 'insertSnippet',
      payload: {
        type: 'mathlive'
      }
    })
    this.emit({ event: 'focus' })
  }

  public insertQuestion(question_type: QuestionType) {
    let sampleCode = question_type.sampleCode
    if (question_type.fieldType != 'textfield') {
      if (this.question!.fieldType) {
        sampleCode = '\n---\n' + sampleCode
      } else if (this.currentLine != '') {
        sampleCode = '\n\n' + sampleCode
      } else if (this.previousLine != '') {
        sampleCode = '\n' + sampleCode
      }
    } else if (this.question!.fieldType && this.question!.fieldType != 'textfield') {
      sampleCode = '\n---\n' + sampleCode
    }

    this.emit({
      event: 'insertSnippet',
      payload: {
        content: sampleCode
      }
    })
    this.emit({ event: 'focus' })
  }

  public addColor(color) {
    this.emit({
      event: 'insertSnippet',
      payload: {
        type: 'color',
        content: color
      }
    })
    this.emit({ event: 'focus' })
  }
}
